var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerHigh = function SvgIconSpeakerHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.25 3a1 1 0 0 0-1.614-.79l-6.48 5.04H3A1.75 1.75 0 0 0 1.25 9v6A1.75 1.75 0 0 0 3 16.75h4.157l6.48 5.04A1 1 0 0 0 15.25 21zM8.5 15.26V8.74l4.75-3.695v13.91zm-2-6.01v5.5H3.25v-5.5zm14.728-2.73a1 1 0 0 0-1.413 1.416 5.74 5.74 0 0 1 0 8.128 1 1 0 1 0 1.413 1.416 7.74 7.74 0 0 0 0-10.96m-2.653 2.653a1 1 0 0 0-1.412 1.417 1.99 1.99 0 0 1 0 2.82 1 1 0 1 0 1.412 1.417 3.99 3.99 0 0 0 0-5.654",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerHigh;